import axios from "axios";
import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { Link, useNavigate } from "react-router-dom";

export default function StreaksList() {
  const config = {
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + localStorage.getItem("_token"),
    },
  };

  const navigate = useNavigate();
  ////////////////////////////////
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [message, setMessage] = useState("");

  const columns = [
    {
      id: "id",
      name: "Id",
      selector: (row) => row.id,
      sortable: true,
    },
    {
      id: "category",
      name: "Category",
      selector: (row) => row.category,
      sortable: true,
    },
    {
      id: "badge_name",
      name: "Badge Name",
      selector: (row) => row.badge_name,
      sortable: true,
    },
    {
      id: "description",
      name: "Description",
      selector: (row) => row.badge_description_detailed,
      sortable: true,
    },
    {
      cell: (row) => (
        <>
          <Link
            to={`/badges/edit?id=${row.id}`}
            className="btn btn-info btn-sm btn-space-custom"
          >
            Edit
          </Link>
          <Link
            className="btn btn-danger btn-sm btn-space-custom"
            title="Delete"
            onClick={() => {
              if (
                window.confirm(
                  "Are you sure to delete this Badges? Action cannot be reversed."
                )
              ) {
                handleDelete(row.id);
              }
            }}
          >
            Delete
          </Link>{" "}
        </>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      // button: true,
    },
  ];

  const fetchBadges = async (page) => {
    setLoading(true);
    try {
      const response = await axios.get(
        process.env.REACT_APP_API_URL +
          `V1/badges/all?page=${page}&per_page=${perPage}&delay=1`,
        config
      );

      setData(response.data.data);
      setTotalRows(response.data.total);
      setLoading(false);
    } catch (err) {
      if (err.response && err.response.status === 401) {
        localStorage.clear();
        navigate("/login");
      } else {
        console.error("API error:", err.message);
      }
    }
  };

  const handlePageChange = (page) => {
    fetchBadges(page);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    setLoading(true);

    const response = await axios.get(
      process.env.REACT_APP_API_URL +
        `V1/badges/all?page=${page}&per_page=${newPerPage}&delay=1`,
      config
    );

    setData(response.data.data);
    setPerPage(newPerPage);
    setLoading(false);
  };

  const handleSearcFilter = async (search, newPerPage = 10, page = 1) => {
    setLoading(true);

    const response = await axios.get(
      process.env.REACT_APP_API_URL +
        `V1/badges/all?page=${page}&per_page=10&delay=1&search=${search}`,
      config
    );
    setTotalRows(response.data.total);
    setData(response.data.data);
    setPerPage(newPerPage);
    setLoading(false);
  };

  const handleDelete = async (id) => {
    const params = { id: id };

    await axios
      .post(process.env.REACT_APP_API_URL + `V1/badges/delete`, params, config)
      .then((response) => {
        setMessage(
          <div className="alert alert-success">
            {response.data.message}
          </div>
        );
        fetchBadges(1);
        setTimeout(() => setMessage(""), 3000);
      })
      .catch((error) => {
        const msg = error?.response?.data?.message || "Failed to delete badge. Please try again.";
        setMessage(
          <div className="alert alert-danger">
            {typeof msg === "object" ? Object.values(msg).flat().join(", ") : msg}
          </div>
        );
        setTimeout(() => setMessage(""), 4000);
      });
  };

  useEffect(() => {
    fetchBadges(1); // fetch page 1 of Streaks
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  ////////////////////////////////
  return (
    <>
      <div className="content-wrapper">
        <div className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h1 className="m-0">Badges</h1>
              </div>
              <div className="col-sm-6">
                <ol className="breadcrumb float-sm-right">
                  <li className="breadcrumb-item">
                    <a href="/#">Home</a>
                  </li>
                  <li className="breadcrumb-item active">Badges</li>
                </ol>
              </div>
            </div>
            <div className="row">
              <div className="col-12 mb-2 my-0">
                <Link to="/badges/create">
                  <button className="btn btn-primary">Add New Badges</button>
                </Link>
              </div>
            </div>
            <div className="card">
              <div className="card-body">
                <div className="row">
                  <div className="col-md-12">{message}</div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <div className="row">
                      <div className="col-md-2">
                        <div className="form-group">
                          <input
                            type="text"
                            placeholder="Search"
                            onChange={(e) => handleSearcFilter(e.target.value)}
                            className="form-control"
                          />
                        </div>
                      </div>
                    </div>
                    <DataTable
                      columns={columns}
                      data={data}
                      progressPending={loading}
                      pagination
                      paginationServer
                      paginationTotalRows={totalRows}
                      onChangeRowsPerPage={handlePerRowsChange}
                      onChangePage={handlePageChange}
                      // defaultSortFieldId="id"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div></div>
    </>
  );
}
